import { ValidatorFn, FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function RangeValidator(min = 'min', max = 'max'): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        if (!(group instanceof FormGroup)) {
            return null;
        }

        if (group.pristine) {
            return null;
        }

        const controlMin = group.get(min);
        const controlMax = group.get(max);

        if (controlMin && controlMax) {
            const error = controlMin.value > controlMax.value ? { range: true } : null;
            setError(controlMin, error, 'range');
            setError(controlMax, error, 'range');
        }

        return null;
    };
}
